import { RootState } from '../../../reducers'
import { AccessLevel } from '../../user/types'
import { SocketLog } from '../../../lib/debugging/socketLog'
import { isBotSoftDeletedSelector } from '../../../features/serverBots/selectors/isBotSoftDeletedSelector'
import { currentBotConfigurationSelector } from '../../../features/serverBots/selectors/currentBotConfigurationSelector'
import { isBotArchivedSelector } from '../../../features/serverBots/selectors/isBotArchivedSelector'
import { isEditingUserSelector } from '../../socketServer/hooks/useIsEditingUser'
import {
  amIBlockedByExclusiveUiSelector,
  exclusiveUiUserSelector,
  mySocketIdSelector
} from '../../socketServer/selectors'
import { isOnDisabledDevBotSelector } from '../../../features/serverBots/actions/promptForDisabledDevResolution'

export function isLockedSelector(state: RootState, log = false): boolean {
  return !!lockedStatePermissionSettingsSelector(state, log)
}

export function lockedStatePermissionSettingsSelector(
  state: RootState,
  log = false
): Partial<AccessLevel> | undefined {
  const { user, socketServer } = state

  let { isConnected, roomState } = socketServer || {}
  const lockedStatePermissionSettings = { edit: false, copywrite: false, deployBot: false }

  if (isOnDisabledDevBotSelector(state)) {
    return lockedStatePermissionSettings
  }

  if (amIBlockedByExclusiveUiSelector(state)) {
    log &&
      SocketLog.log('Notice', 'Locked - exclusive UI', {
        exclusiveUiUser: exclusiveUiUserSelector(state),
        mySockedId: mySocketIdSelector(state),
        state
      })
    return lockedStatePermissionSettings
  }

  if (isBotSoftDeletedSelector(state)) {
    log &&
      SocketLog.log('Notice', 'Locked - bot soft deleted', {
        softDeletedAtTimestamp: currentBotConfigurationSelector(state)?.softDeletedAtTimestamp
      })
    return lockedStatePermissionSettings
  }

  if (isBotArchivedSelector(state)) {
    log &&
      SocketLog.log('Notice', 'Locked - bot archived', {
        archivedAtTimestamp: currentBotConfigurationSelector(state)?.archivedAtTimestamp
      })
    return lockedStatePermissionSettings
  }

  if (!roomState) {
    log && SocketLog.log('Notice', 'Locked - no room state', { roomState })
    return
  }

  if (!isConnected) {
    log && SocketLog.log('Notice', 'Locked - not connected', { isConnected })
    return lockedStatePermissionSettings
  }

  if (!roomState?.botState?.diff) {
    log && SocketLog.log('Notice', 'Locked - no diff', { roomState })
    return
  }

  if (!isEditingUserSelector({ socketServer, user })) {
    log && SocketLog.log('Notice', 'Locked - not editing', { socketServer, user })
    return lockedStatePermissionSettings
  }

  log && SocketLog.log('Notice', 'NOT Locked - default', { state })
}
